<!-- 地图 -->
<style lang="stylus" scoped>
.center
  height 786px
  padding 5px
  background-size 100% 100%
</style>

<template>
  <div>
    <div class="center">
      <centerTop></centerTop>
      <centerMap></centerMap>
      <centerBottom></centerBottom>
    </div>
  </div>
</template>

<script>
import centerTop from './centerTop';
import centerMap from './centerMap';
import centerBottom from './centerBottom';

export default {
  props: {
    child: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      areaName: ''
    }
  },
  components: {
    centerTop,
    centerMap,
    centerBottom
  },
  methods: {
  },
  mounted() {
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?099d6642